import "../../new.scss";
import { useState, useEffect, useContext } from "react";
import { SucursalesFormContext } from '../../../context/sucursales/SucursalesContext';
import { useParams, useNavigate } from 'react-router-dom';
import ConfirmationDialog from "../../../components/dialogs/ConfirmationDialog";
import ErrorDialog from "../../../components/dialogs/ErrorDialog";
import FormField from "../../../components/FormField/FormField";
import FormButtons from "../../../components/FormButtons/FormButtons";
import ImagePreview from "../../../components/preview/imagePreview";
import Inputs from "./configForm/inputs";
import { handleInputChange } from "./helpersForm/formHandlers";

const IP_ADDRESS = process.env.REACT_APP_URL_BACKEND;

export const Form = ({ title }) => {

  const [form, setForm] = useState({});
  const { postSucursalData, report, patchSucursalData } = useContext(SucursalesFormContext);

  const { id } = useParams();
  const navigate = useNavigate();

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // imágenes
  const [imageUrlLocal, setImageUrlLocal] = useState(null);
  const [imageUrlServer, setImageUrlServer] = useState(null);
  const [selectViewValue, setSelectViewValue] = useState('vistaImagen');

  const nameData = "sucursales";

  // Cargar datos de report para editar
  useEffect(() => {
    if (report) {
      setForm(report);
      setImageUrlServer(report.imagen);
      if (report.imagen_maps) {
        setSelectViewValue('vistaMaps');  // Cargar la opción seleccionada
      } else {
        setSelectViewValue('vistaImagen');  // Cargar la opción seleccionada
      }
    }
  }, [report]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "selectView") {
      setSelectViewValue(value);

      setForm(prev => ({
        ...prev,
        selectView: value
      }));


      return;
    }

    handleInputChange(
      e,
      setForm,
      Inputs(selectViewValue),
      setErrors,
      form,
      setImageUrlLocal,
      selectViewValue
    );
  };

  const validateForm = () => {
    let formErrors = {};
    Inputs(selectViewValue).forEach(({ name, validation }) => {
      if (validation) {
        const error = validation(form[name] || "", form);
        if (error) formErrors[name] = error;
      }
    });
    setErrors(formErrors);
    return !Object.keys(formErrors).length;
  };

  const handleSendData = () => {
    if (!validateForm()) {
      const errorArray = Inputs(selectViewValue).reduce((acc, { name, label }) => {
        if (errors[name]) acc.push(`${label}: ${errors[name]}`);
        return acc;
      }, []);

      if (errorArray.length > 0) openErrorDialog(errorArray);
      return;
    }

    openConfirmDialog();
  };

  const confirmSendData = async () => {
    setIsSubmitting(true);
    closeConfirmDialog();

    const formData = new FormData();

    // Cargar campos normales excepto imagen e imagen_maps
    Object.keys(form).forEach(key => {
      if (key === "imagen" || key === "imagen_maps" || key === "selectView") return;
      if (form[key] !== undefined && form[key] !== null) {
        formData.append(key, form[key]);
      }
    });

    // IMAGEN o MAPA segun selectView
    if (form.selectView === "vistaImagen") {
      if (form.imagen) {
        formData.append("imagen", form.imagen);
      }
      formData.append("imagen_maps", ""); // forzar null
    }

    if (form.selectView === "vistaMaps") {
      if (form.imagen_maps) {
        formData.append("imagen_maps", form.imagen_maps);
      }
      formData.append("imagen", ""); // forzar null
    }

    try {
      if (id) {
        await patchSucursalData(id, formData);
      } else {
        await postSucursalData(formData);
      }

      navigate(`/${nameData}`);

    } catch (error) {
      console.error(error);
      openErrorDialog("Error al guardar los datos. Intenta nuevamente.");
    } finally {
      setIsSubmitting(false);
    }
  };


  const openConfirmDialog = () => setIsConfirmDialogOpen(true);
  const closeConfirmDialog = () => setIsConfirmDialogOpen(false);

  const openErrorDialog = (message) => {
    setErrorMessage(message);
    setIsErrorDialogOpen(true);
  };
  const closeErrorDialog = () => setIsErrorDialogOpen(false);

  const handleCancel = () => {
    navigate(`/${nameData}`, { state: { fromDetail: true } });
  };
  return (
    <div className="new">
      <div className="newContainer">
        <div className="top">
          <h1>{title}</h1>
        </div>

        {/* Vista previa usando el componente ImagePreview */}
        {!isSubmitting && (
          <ImagePreview
            title="Vista previa del logo"
            imageUrl={imageUrlLocal || (imageUrlServer && `${IP_ADDRESS}${imageUrlServer}`)}
            height="300px"        // default: 220px
            objectFit="contain"   // default: "cover" — útil para logos que no deben recortarse
            altText="Logo empresa"
          />
        )}

        <div className="bottom">
          <div className="right">
            <form>
              {Inputs(selectViewValue)  // Pasamos el valor de selectView
                .map((input) => (
                  <FormField
                    key={input.name}
                    input={input}
                    value={form[input.name]}
                    handleInputChange={handleChange}
                    error={errors[input.name]}
                  />
                ))}
 </form>
              <FormButtons
                isSubmitting={isSubmitting}
                handleSave={handleSendData}
                handleCancel={handleCancel}
                saveText="Guardar"
                cancelText="Cancelar"
              />
            

            <ConfirmationDialog
              isOpen={isConfirmDialogOpen}
              onClose={closeConfirmDialog}
              onConfirm={confirmSendData}
              title=""
              message="¿Estás seguro de que deseas guardar este registro?"
            />

            <ErrorDialog
              isOpen={isErrorDialogOpen}
              onClose={closeErrorDialog}
              messages={errorMessage}
              title=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Form;
